export const ApckWhatsNewSpinner = {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        useWrapper: {
            type: Boolean,
            default: true,
        },
        animation: {
            type: String,
            default: 'spinner-wrapper',
        },
        title: {
            type: String,
            default: 'Loading...',
        },
    },
    template: `
        <transition :name="animation" tag="div" mode="out-in">
            <component
                v-if="show"
                is="div"
                :class="useWrapper ? 'whats-new__spinner-wrapper' : 'whats-new__spinner'"
                :aria-hidden="true"
                :title="useWrapper ? '' : title"
            >
                <div v-if="useWrapper" class="whats-new__spinner" aria-hidden="true" :title="title">
                    <span></span>
                </div>
                <span v-else></span>
            </component>
        </transition>
    `,
}
